var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import OutlinedInput from '@commoncomponents/frontend-components/dist/components/OutlinedInput';
const ACTIVATION_CODE_WITHOUT_DASHES_LENGTH = 20;
const MaskedInputCustom = (props) => {
    const { inputRef, showMask } = props, other = __rest(props, ["inputRef", "showMask"]);
    const regex = /[a-z0-9]/i;
    return (React.createElement(MaskedInput, Object.assign({}, other, { ref: (ref) => {
            inputRef(ref ? ref.inputElement : null);
        }, keepCharPositions: true, mask: [
            regex,
            regex,
            regex,
            regex,
            '-',
            regex,
            regex,
            regex,
            regex,
            '-',
            regex,
            regex,
            regex,
            regex,
            '-',
            regex,
            regex,
            regex,
            regex,
            '-',
            regex,
            regex,
            regex,
            regex,
        ], showMask: showMask })));
};
const ActivationCodeInput = ({ label, errorMessage, infoMessage, autoFocus, disabled, onChange, onFocus, }) => {
    const [shouldShowMask, setShouldShowMask] = useState(false);
    const [isPasted, setIsPasted] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const handleChange = (event) => {
        if (isPasted) {
            setIsPasted(false);
        }
        else {
            const value = event.target.value;
            onCodeInputValueChange(value);
        }
    };
    const handlePaste = (e) => {
        const codeValue = e.clipboardData.getData('text/plain');
        const isAllCodePasted = codeValue.length >= ACTIVATION_CODE_WITHOUT_DASHES_LENGTH;
        if (isAllCodePasted) {
            const formatedCodeValue = formatCode(codeValue);
            setIsPasted(true);
            onCodeInputValueChange(formatedCodeValue);
        }
    };
    const formatCode = (code) => {
        const codeWithoutDashes = parseInputValueToCodeFormat(code);
        const firstPart = codeWithoutDashes.slice(0, 4);
        const secondPart = codeWithoutDashes.slice(4, 8);
        const thirdPart = codeWithoutDashes.slice(8, 12);
        const fourthPart = codeWithoutDashes.slice(12, 16);
        const fifthPart = codeWithoutDashes.slice(16);
        return `${firstPart}-${secondPart}-${thirdPart}-${fourthPart}-${fifthPart}`;
    };
    const onCodeInputValueChange = (value) => {
        onChange(value);
        setInputValue(value);
    };
    const parseInputValueToCodeFormat = (value) => value.replace(/[_,-\s+]/g, '');
    return (React.createElement(OutlinedInput, { className: "activation-code-input", label: label, value: inputValue, errorMessage: errorMessage, infoMessage: infoMessage, onChange: handleChange, onPaste: handlePaste, onFocus: () => {
            if (onFocus)
                onFocus();
            setTimeout(() => setShouldShowMask(true), 50);
        }, onBlur: () => {
            if (parseInputValueToCodeFormat(inputValue).length === 0)
                setShouldShowMask(false);
        }, inputComponent: MaskedInputCustom, inputProps: { showMask: shouldShowMask, spellCheck: false }, autoFocus: autoFocus, disabled: disabled, fullWidth: true, required: true }));
};
export default ActivationCodeInput;
